import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError, ITotalItems } from '@unfoldrtech/portal-mic'
import {
  EReportColumnHeader,
  IReportingTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/openapi/core/sdk/api'
import { coreAPI } from '../services/coreAPI'
import {
  generateCorrelationId,
  getTZOffset,
  getTimezone,
} from '../utils/helpers'
import {
  TAdGroupsReportTableFilters,
  TPPAdvertiserId,
  TPPRetailerId,
} from '../models/types'
import { IReportPageTypes } from '../models/interfaces'

export default function useGetV2RetailerReportingAdGroupsTable({
  advertiserId,
  retailerId,
  inventoryType,
  campaignIds,
  adGroupIds,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzOffset,
  tzZone,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TAdGroupsReportTableFilters &
  TPPRetailerId &
  TPPAdvertiserId &
  IReportPageTypes): UseQueryResult<
  AxiosResponse<ITotalItems & IReportingTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingAdGroupsTable_${retailerId}_${advertiserId}_${
    inventoryType || ''
  }`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    ({ queryKey }) => {
      const filters = queryKey[1] || {}
      const { start, end } = filters as { start: string; end: string }

      return coreAPI
        .v2RetailerReporting()
        .getRetailerAdGroupsReportTable(
          retailerId,
          generateCorrelationId(),
          advertiserId,
          inventoryType,
          campaignIds,
          adGroupIds,
          sortBy as EReportColumnHeader,
          sortOrder,
          timeWindow,
          start,
          end,
          tzOffset || getTZOffset(endDate),
          tzZone || getTimezone()
        )
    },
    { suspense, enabled }
  )
}
